import React, { useState, useEffect, useRef } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import Link from "@material-ui/core/Link";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

import { useForm } from "react-hook-form";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function ResetPassword(props) {
  const history = useNavigate();
  const classes = useStyles();
  const { token, company } = useParams();
  const resetPasswordURL = `${process.env.REACT_APP_SERVER_API}/clientUser/resetPassword`;
  const checkTokenURL = `${process.env.REACT_APP_SERVER_API}/clientUser/checkToken`;

  const defaultValues = {
    role: "User",
  };

  const {
    register,
    watch,
    handleSubmit,
    setError,
    control,
    formState: { errors },
  } = useForm({ defaultValues });

  const [show, setShow] = useState(true);
  const password = useRef({});
  password.current = watch("newPassword", "");

  useEffect(() => {
    axios
      .post(checkTokenURL, {
        token: token,
      })
      .then((res) => {
        setShow(true);
      })
      .catch((err) => {
        if (err) {
          Swal.fire({
            text: "Token Expired/Invalid",
            icon: "error",
          }).then(() => {
            history(`/login/${company}`);
          });
          setShow(false);
        }
      });
    return () => {
      setShow(true);
    };
  }, []);

  const onSubmit = async (data) => {
    axios
      .put(resetPasswordURL, {
        resetLink: token,
        newPassword: data.newPassword2,
      })
      .then((res) => {
        alert(
          "You password has been reset, now you can login with your new password"
        );
        history(`/login/${company}`);
      })
      .catch((err) => {
        if (err) {
          if (err.response.data)
            setError("newPassword2", {
              message: err.response.data.message,
            });
        }
      });
  };

  if (show) {
    return (
      <div className="flex justify-center items-center h-screen flex-col text-center">
        {/* <Menu title="Change My Password"/> */}
        <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="newPassword"
                  label="New Password"
                  name="newPassword"
                  type="password"
                  autoComplete="newPassword"
                  {...register("newPassword", {
                    required: "New Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must longer than 8",
                    },
                  })}
                />
                {errors.newPassword && (
                  <p className="signUpErrorMessage">
                    {errors.newPassword.message}
                  </p>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="newPassword2"
                  label="Enter password again"
                  name="newPassword2"
                  type="password"
                  autoComplete="newPassword2"
                  {...register("newPassword2", {
                    required: "Re-Enter Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must longer than 8",
                    },
                    validate: (value) =>
                      value === password.current ||
                      "The new passwords do not match",
                  })}
                />
                {errors.newPassword2 && (
                  <p className="signUpErrorMessage">
                    {errors.newPassword2.message}
                  </p>
                )}
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Change My Password
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href={`/resetpassword/${company}`} variant="body2">
                  Resend the reset link
                </Link>
              </Grid>
              {/* <Grid item>
              <Link href="/signUp" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid> */}
            </Grid>
          </form>
        </div>
      </div>
    );
  } else {
    return <h1>This is invalid link, Your token is incorrect or expired!</h1>;
  }
}
